"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiPaperPlaneRight } from "react-icons/pi";
import NewsletterCard from "./NewsletterCard";

// Default/Simple Newsletter (V1)
function NewsletterSimple({ content, onContentChange, isSelected }: SectionContentProps) {
    const primaryColor = content.colorPalette?.primary || "#3B82F6";
    const fontFamily = content.fontFamily || "inherit";

    return (
        <section className={`px-6 py-24 ${isSelected ? "ring-2 ring-blue-500" : ""}`} style={{ fontFamily, backgroundColor: primaryColor }}>
            <div className="max-w-4xl mx-auto text-center text-white">
                <h2 className="text-4xl md:text-5xl font-black tracking-tight mb-6">
                    <EditableText value={content.title || "Stay in the loop"} onChange={(v) => onContentChange?.({ ...content, title: v })} />
                </h2>
                <p className="text-xl md:text-2xl opacity-90 mb-12 max-w-2xl mx-auto leading-relaxed">
                    <EditableText
                        as="span"
                        value={content.description || "Join our newsletter and get exclusive updates, tips, and offers directly to your inbox."}
                        onChange={(v) => onContentChange?.({ ...content, description: v })}
                    />
                </p>

                <div className="bg-white p-2 rounded-2xl md:rounded-full shadow-2xl max-w-xl mx-auto flex flex-col md:flex-row gap-2">
                    <input
                        type="email"
                        placeholder={content.placeholder || "Enter your email address"}
                        className="flex-1 px-6 py-4 md:py-3 rounded-xl md:rounded-full text-gray-900 placeholder:text-gray-400 outline-none border-none text-lg"
                    />
                    <button
                        className="px-8 py-4 md:py-3 rounded-xl md:rounded-full font-bold text-white transition-all hover:opacity-90 flex items-center justify-center gap-2"
                        style={{ backgroundColor: primaryColor }}
                    >
                        <EditableText value={content.buttonText || "Subscribe"} onChange={(v) => onContentChange?.({ ...content, buttonText: v })} />
                        <PiPaperPlaneRight className="text-xl" />
                    </button>
                </div>
                <p className="mt-8 text-xs opacity-60 font-medium uppercase tracking-widest">
                    No spam, unsubscribe anytime.
                </p>
            </div>
        </section>
    );
}

// Main Controller
export default function NewsletterSection(props: SectionContentProps) {
    const variant = props.content?.variant || "v1";

    switch (variant) {
        case "v2":
        case "newsletter-v2":
        case "card":
            return <NewsletterCard {...props} />;
        case "v1":
        case "newsletter-v1":
        case "simple":
        default:
            return <NewsletterSimple {...props} />;
    }
}
